import GirosMdl  from '@/models/General/GCoreBusinessSii'
const percentage_rules = (val) =>{
    let isnum = /^\d+$/.test(val);
    if(!isnum){
        return 'Debe ingresar solo numero'
    }
    if(val<0 || val>100){
      return 'pocentaje entre 0 - 100 %'
    }
    
    return true
}
export default (giros=[]  )=>[
    {
        name: 'rut',
        type: 'rut-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Rut',
        },
    },
    {
        name: 'business_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Razón social',
        },
    },
    {
        name: 'alias_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Nombre fantasía',
        },
    },
    // {
    //     name: 'core_business',
    //     type: 'text-field',
    //     flex: {
    //         sm6: true,
    //         lg6: true,
    //     },
    //     props: {
    //         label: 'Giro',
    //     },
    // },
    {
        name: "core_business",
        type: "autocomplete",
        flex: {
            sm6: true,
        },
        props: {
            chips: true,
            itemText: "core_business",
            itemValue: "id",
            label: "Giros",
            loadingText: "Cargando giros...",
            //model: GirosMdl,
            items:giros,
            noDataText: "Sin giros.",
            multiple:true,
            paramSearch:'core_business',
            noObject:true,
        },
    },    
    {
        name: 'email_collection',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Email cobranza',
        },
    },
    {
        name: 'discount',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Porcentaje descuento',
            rules:[percentage_rules],
        },
    },
    {
        name: 'charge',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Porcentaje recargo',
            rules:[percentage_rules],
        },
        
    },
]
